
import React, { useEffect, useRef, useState } from "react";
import { Row, Col } from 'reactstrap';
import { CaretLeftDarkIcon, CaretRightDarkIcon } from '../../components/Icons';
import { Link } from 'react-router-dom';
import './RecommendDR.css';

function getSignColor(oldValue, newValue) {
    if (oldValue > newValue) {
        return "red";
    }
    else if (newValue > oldValue) {
        return "green";
    }
    else {
        return "black";
    }
}
export default function RecommendDR({ mode, symbol }) {
    const ref = useRef(null);
    const [firstIndex, setFirstIndex] = useState(1);

    const scrollToPrevDR = () => {
        if (firstIndex > 1) {
            var boxWidth = ref.current?.children[1]?.getBoundingClientRect().width;
            var totalWidth = ref.current.children.length * boxWidth;
            var contianer = ref.current.getBoundingClientRect();
            var nextIndex = firstIndex - 1;
            setFirstIndex(nextIndex);

            if (((nextIndex - 1) * boxWidth) < totalWidth) {
                ref.current?.scroll((nextIndex - 1) * boxWidth, contianer.y);
            }
        }
    };

    const scrollToNextDR = () => {
        var contianer = ref.current.getBoundingClientRect();
        var boxWidth = ref.current?.children[1]?.getBoundingClientRect().width;
        var displayCount = contianer.width / boxWidth;

        if (firstIndex <= ref.current.children.length - displayCount + 1) {
            var nextIndex = firstIndex + 1;
            

            var totalWidth = ref.current.children.length * boxWidth;
            setFirstIndex(nextIndex);

            if (((nextIndex - 1) * boxWidth) < totalWidth) {
                ref.current?.scrollTo({ left: (nextIndex - 1) * boxWidth, top: contianer.y, behavior: 'smooth' });
            }
        }
    };

    const [drData, setDrData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        async function fecthDrData() {
            let url = 'api/MarketData/GetMarketData';
            let response = await fetch(url);
            let data = await response.json();

            if(symbol) {
                data = data.filter(obj => obj.symbol !== symbol)
            }

            setDrData(data);
            setIsLoading(false);
        }
        fecthDrData();
    }, [symbol]);

    if (isLoading) {

        return <div id="recommend-dr" className="content-section">
            <Row>
                <Col><h1 className="h-highlight">หุ้น DR แนะนำ</h1></Col>
                <Col md={2} xs={4} className="recommend-dr-buttons">
                    <button onClick={scrollToPrevDR}><CaretLeftDarkIcon /></button>
                    <button onClick={scrollToNextDR}><CaretRightDarkIcon /></button>
                </Col>
            </Row>
            <Row>
                <Col>
                    <p><em>Loading...</em></p>
                </Col>
            </Row>
        </div>
    }


    return <div id="recommend-dr" className="content-section">
        <Row>
            <Col>
                {mode === 'related' ? <h1>หุ้น DR ตัวอื่นๆ</h1> : <h1 className="h-highlight">หุ้น DR แนะนำ</h1>}
            </Col>
            <Col md={2} xs={4} className="recommend-dr-buttons">
                <button onClick={scrollToPrevDR}><CaretLeftDarkIcon /></button>
                <button onClick={scrollToNextDR}><CaretRightDarkIcon /></button>
            </Col>
        </Row>
        <Row>
            <Col>
                <div ref={ref} className="recommend-box-container">
                    {drData.map((i) => <div key={`recommend-box-${i.symbol}`} className="recommend-box-wraper">

                        <Link className="recommend-box" to={`/DRDetail/${i.symbol}`}>
                            <div>
                                <div>
                                    <img alt="" src={i.iconUrl} />
                                </div>
                                <div>
                                    <h3>{i.symbol}</h3>
                                    <div className="recommend-box-content">
                                        <div className="recommend-dr-price">
                                            <p>{i.displayLastPrice}</p>
                                            <p className={getSignColor(i.priorPrice, i.lastPrice)}>{i.displayPercentChange} %</p>
                                        </div>
                                        <div>
                                            <small>Bid</small>
                                            <p>{i.displayBestBidPrice}</p>
                                        </div>
                                        <div>
                                            <small>Ask</small>
                                            <p>{i.displayBestOfferPrice}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>)}
                </div>

            </Col>
        </Row>
    </div>
}